export function setAddresses (state, addresses) {
  state.addresses = addresses
}

export function setAddress (state, address) {
  state._address = address
}
